import type { FaireProductEntity } from "../../entity_types/product";

export const p_wzjm6yasbt: FaireProductEntity = {
  token: "p_wzjm6yasbt",
  type: "product",
  name: "Brianne Hoops",
  brandToken: "b_fcca911f",
  brandName: "Mod + Jo",
  imageUrl:
    "https://cdn.faire.com/fastly/c51c0b9adad601f5e21ed0a4cf5097253d29f14a56597205abf9c2d5bad22b67.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/219b8f8d3494fa80cdb95f0d6dfef0dfc5f15294f08fec755b31c54156c81c51.png",
  ],
  priceDollars: 32.5,
  description:
    "\nFrom the office to GNO, the Brianne Hoops are the perfect finishing touch to your look. These versatile hoops are petite and lightweight for everyday wear. Dress them up with a LBD or keep it casual with jeans and a tee, the Brianne Hoops are always the right choice.\n\n * Tarnish-resistant 14k gold-plating that is long-lasting with proper care\n\n * Cubic zirconia accents \n * 11mm diameter \n * Nickel- and lead-free \n\n",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:53.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
